import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './UserDashboard.css'; // Reusing dashboard styles

const Profile = () => {
  const { currentUser, updateUser } = useAuth();
  const [formData, setFormData] = useState({
    name: currentUser?.name || '',
    email: currentUser?.email || '',
    phone: currentUser?.phone || '',
  });
  const [isEditing, setIsEditing] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleCancel = () => {
    setIsEditing(false);
    // Reset form data to current user data
    setFormData({
      name: currentUser?.name || '',
      email: currentUser?.email || '',
      phone: currentUser?.phone || '',
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    try {
      // In a real app, you would update the user profile on the server
      // For now, we'll just update the local state
      updateUser(formData);
      setIsEditing(false);
      setMessage({ text: 'Profile updated successfully', type: 'success' });
      
      // Clear message after 3 seconds
      setTimeout(() => {
        setMessage({ text: '', type: '' });
      }, 3000);
    } catch (error) {
      setMessage({ text: 'Failed to update profile', type: 'error' });
    }
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-card">
        <h2>My Profile</h2>
        
        {message.text && (
          <div className={`message ${message.type}`}>
            {message.text}
          </div>
        )}
        
        <div className="profile-info">
          {isEditing ? (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  disabled // Email shouldn't be editable for security
                />
                <small>Email cannot be changed</small>
              </div>
              
              <div className="form-group">
                <label htmlFor="phone">Phone</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
              
              <div className="form-buttons">
                <button type="submit" className="primary-btn">Save Changes</button>
                <button type="button" className="secondary-btn" onClick={handleCancel}>Cancel</button>
              </div>
            </form>
          ) : (
            <>
              <div className="info-item">
                <strong>Name:</strong> <span>{currentUser?.name}</span>
              </div>
              <div className="info-item">
                <strong>Email:</strong> <span>{currentUser?.email}</span>
              </div>
              <div className="info-item">
                <strong>Phone:</strong> <span>{currentUser?.phone || 'Not provided'}</span>
              </div>
              <div className="info-item">
                <strong>Account Type:</strong> <span>{currentUser?.role === 'admin' ? 'Administrator' : 'User'}</span>
              </div>
              
              <button className="primary-btn" onClick={handleEdit}>Edit Profile</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile; 